export default {"src":"/_next/static/media/minillus-earth.d08393ce.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};